module.exports = __webpack_public_path__ + "img/logo2.c0d41697.png";